// Cache TTL constants in milliseconds.
// Lives in its own module so consumers (e.g. CacheManager) don't pull in the
// rest of validationUtil's heavy dependency graph and avoid circular-init bugs.
export const TTL = {
    DAY: 86_400_000,    // 24 * 60 * 60 * 1000 (1 day)
    HOUR: 3_600_000,    // 60 * 60 * 1000 (1 hour)
    MIN_30: 1_800_000,  // 30 * 60 * 1000 (30 minutes)
    MIN_15: 900_000,    // 15 * 60 * 1000 (15 minutes)
    MIN_10: 600_000,    // 10 * 60 * 1000 (10 minutes)
    MIN_5: 300_000,     // 5 * 60 * 1000 (5 minutes)
    MIN_2: 120_000,     // 2 * 60 * 1000 (2 minutes)
} as const;
